import React from 'react'
import VeranstalterScoringArea from "./VeranstalterScoringArea";
import DHDialog from "../../general/DHDialog";

export default function BoardsVerwaltenDialog({eventOperatorId, onClose}) {

    return  <DHDialog onClose={onClose} buttons={[]} showCloseButton={true} title="Boards verwalten"
                      comp={<VeranstalterScoringArea eventOperatorId={eventOperatorId}/>}/>
}
